import React, { useEffect, useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [platformDropdownOpen, setPlatformDropdownOpen] = useState(false);
  const [companyDropdownOpen, setCompanyDropdownOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = ['Contact'];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm border-b border-line py-3' : 'bg-white border-b border-line py-4'}`} data-id="element-1257" data-mp="f02a7iwss4v9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1258" data-mp="ozt6nq4x4txz">
        <div className="flex justify-between items-center" data-id="element-1259" data-mp="dfz63log9bjp">
          {/* Logo Area */}
          <div className="flex items-center" data-id="element-1260" data-mp="hhaz816j8ewn">
            <a href="#home" className="flex items-center" aria-label="SyNeural home" data-id="element-1261" data-mp="hi2h6977ie4g">
              <img src="https://cdn.magicpatterns.com/uploads/pa3Fk96C6qU6AFqdF9EfnU/ChatGPT_Image_Aug_25,_2026,_10_57_05_AMff.png" alt="SyNeural — Creating an Intelligent Web" className={`w-auto transition-all duration-200 ${isScrolled ? 'h-8' : 'h-10'}`} data-id="element-1262" data-mp="mfcfyfghk24y" />
            </a>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-1263" data-mp="156ddr05vdrmx">
            <ul className="flex items-center gap-6" data-id="element-1264" data-mp="158yfzqa2y9l7">
              {/* Platform Dropdown */}
              <li className="relative" data-id="element-1265" data-mp="1a82p6gx087bj">
                <button onMouseEnter={() => setPlatformDropdownOpen(true)} onMouseLeave={() => setPlatformDropdownOpen(false)} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors flex items-center gap-1" aria-expanded={platformDropdownOpen} data-id="element-1266" data-mp="1f5l02cul0wm6">
                  Products
                  <ChevronDown size={14} className={`transition-transform ${platformDropdownOpen ? 'rotate-180' : ''}`} data-id="element-1267" data-mp="145jvfx598ngm" />
                </button>

                <AnimatePresence data-id="element-1268" data-mp="1d68cl0py33xq">
                  {platformDropdownOpen && <motion.div initial={{
                  opacity: 0,
                  y: -10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -10
                }} transition={{
                  duration: 0.2
                }} onMouseEnter={() => setPlatformDropdownOpen(true)} onMouseLeave={() => setPlatformDropdownOpen(false)} className="absolute top-full left-0 mt-2 w-80 bg-white rounded-lg shadow-lg border border-line py-2" data-id="element-1269" data-mp="187f79vktaj8n">
                      <a href="#human-capability" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1270" data-mp="1uo732kiiwj1z">
                        <div className="font-semibold" data-id="element-1271" data-mp="1kprcqjrbldtj">Human Capability Platform</div>
                        <div className="text-xs text-ink-muted" data-id="element-1272" data-mp="16q83toqopyg6">
                          Reasoning, judgment & leadership readiness
                        </div>
                      </a>
                      <div className="ml-4 border-l border-line" data-id="element-1273" data-mp="1br5vcrxl44uc">
                        <a href="#cji" className="block pl-4 pr-4 py-1.5 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1274" data-mp="314sjto4295t8">
                          <span className="font-semibold" data-id="element-1275" data-mp="160babivu5xq3">CJI</span>
                          <span className="text-ink-muted" data-id="element-1276" data-mp="1132sxkiihxpw"> · Civic Judgment Index</span>
                        </a>
                        <a href="#ncji" className="block pl-4 pr-4 py-1.5 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1277" data-mp="wyuzja13ztlc">
                          <span className="font-semibold" data-id="element-1278" data-mp="n4bgs3n7mm4e">NCJI</span>
                          <span className="text-ink-muted" data-id="element-1279" data-mp="iaqfa1mera0g"> · Neurocognitive Index</span>
                        </a>
                      </div>
                      <a href="#semantic-knowledge" className="block px-4 py-2 mt-1 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1280" data-mp="da2pfj9x0z7t">
                        <div className="font-semibold" data-id="element-1281" data-mp="3vibrf5er5hei">Semantic Knowledge Platform</div>
                        <div className="text-xs text-ink-muted" data-id="element-1282" data-mp="2azzsf9cyabem">
                          Connected evidence & knowledge graphs
                        </div>
                      </a>
                      <div className="border-t border-line my-2" data-id="element-1283" data-mp="2g0xa7ku1t3fl"></div>
                      <a href="#solutions" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1284" data-mp="2kyp1qdqs6nj9">
                        <div className="font-semibold" data-id="element-1285" data-mp="1sbcpawec3w3o">Solutions</div>
                        <div className="text-xs text-ink-muted" data-id="element-1286" data-mp="1x9o0bagd8cnh">
                          Applications & Use Cases
                        </div>
                      </a>
                    </motion.div>}
                </AnimatePresence>
              </li>

              {/* Company Dropdown */}
              <li className="relative" data-id="element-1287" data-mp="19i8tp5hk396f">
                <button onMouseEnter={() => setCompanyDropdownOpen(true)} onMouseLeave={() => setCompanyDropdownOpen(false)} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors flex items-center gap-1" data-id="element-1288" data-mp="19h7dynplhyid">
                  Company
                  <ChevronDown size={14} className={`transition-transform ${companyDropdownOpen ? 'rotate-180' : ''}`} data-id="element-1289" data-mp="2qluhdnd6pw9j" />
                </button>

                <AnimatePresence data-id="element-1290" data-mp="1xvvlb80koyvd">
                  {companyDropdownOpen && <motion.div initial={{
                  opacity: 0,
                  y: -10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: -10
                }} transition={{
                  duration: 0.2
                }} onMouseEnter={() => setCompanyDropdownOpen(true)} onMouseLeave={() => setCompanyDropdownOpen(false)} className="absolute top-full left-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-line py-2" data-id="element-1291" data-mp="1sxu30paz13ky">
                      <a href="#about" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1292" data-mp="3gv381hbai5rg">
                        <div className="font-semibold" data-id="element-1293" data-mp="decxqq8od6jy">About</div>
                        <div className="text-xs text-ink-muted" data-id="element-1294" data-mp="dgpckuj4z0ss">
                          Mission & Vision
                        </div>
                      </a>
                      <a href="#research" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1295" data-mp="3nrsijyhx3s2">
                        <div className="font-semibold" data-id="element-1296" data-mp="w5vysrj52ajc">Research</div>
                        <div className="text-xs text-ink-muted" data-id="element-1297" data-mp="2s8seiilv3rjr">
                          Future Work
                        </div>
                      </a>
                      <a href="#partnerships" className="block px-4 py-2 text-sm text-ink-dark hover:bg-surface-muted transition-colors" data-id="element-1298" data-mp="2nffoq55g5epf">
                        <div className="font-semibold" data-id="element-1299" data-mp="2ef13f5shfzlx">Partnerships</div>
                        <div className="text-xs text-ink-muted" data-id="element-1300" data-mp="3b6l7as2rul3f">
                          Collaborate with Us
                        </div>
                      </a>
                    </motion.div>}
                </AnimatePresence>
              </li>

              {navItems.map(item => <li key={item} data-id="element-1301" data-mp="2x9g20uavtq98">
                  <a href={`#${item.toLowerCase()}`} className="text-sm font-medium text-ink-muted hover:text-navy transition-colors" data-id="element-1302" data-mp="1qr00cce2pbdw">
                    {item}
                  </a>
                </li>)}
            </ul>
            <div className="w-px h-5 bg-line" data-id="element-1303" data-mp="1gn3371y2imp6"></div>
            <a href="#contact" className="bg-navy hover:bg-navy-light text-white text-sm font-medium px-5 py-2.5 rounded-md transition-colors shadow-sm whitespace-nowrap" data-id="element-1304" data-mp="1gnumbdaharyk">
              Request Demo
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden text-ink-dark p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-1305" data-mp="1uehmzazsurxa">
            {mobileMenuOpen ? <X size={24} data-id="element-1306" data-mp="24dox7pb8m6g6" /> : <Menu size={24} data-id="element-1307" data-mp="24b2sryjn8726" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav Drawer */}
      <AnimatePresence data-id="element-1308" data-mp="9yw4pz5nhvsg">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-white border-b border-line overflow-hidden" data-id="element-1309" data-mp="a07hupkzkfw8">
            <div className="px-4 pt-2 pb-6 space-y-1 shadow-inner" data-id="element-1310" data-mp="32wjbsumn06po">
              {/* Platform submenu */}
              <div className="border-b border-line pb-2 mb-2" data-id="element-1311" data-mp="37xgtl63qiyqn">
                <div className="text-xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2" data-id="element-1312" data-mp="3cw0ed36le4hf">
                  Products
                </div>
                <a href="#human-capability" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1313" data-mp="3ht0nxo2nhpda">
                  Human Capability Platform
                </a>
                <a href="#cji" className="block pl-7 pr-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1314" data-mp="3vkf5rrktnkir">
                  CJI
                </a>
                <a href="#ncji" className="block pl-7 pr-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1315" data-mp="9mvmyr0u0u1k">
                  NCJI
                </a>
                <a href="#semantic-knowledge" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1316" data-mp="x9llvjhvw8hy">
                  Semantic Knowledge Platform
                </a>
                <a href="#solutions" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1317" data-mp="jh5p30fkt6ph">
                  Solutions
                </a>
              </div>

              {/* Company submenu */}
              <div className="border-b border-line pb-2 mb-2" data-id="element-1318" data-mp="3afs0yel4jmfd">
                <div className="text-xs font-semibold text-ink-muted uppercase tracking-wider px-3 py-2" data-id="element-1319" data-mp="2vsgsilk8oijh">
                  Company
                </div>
                <a href="#about" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1320" data-mp="30pgx0s1fxd8h">
                  About
                </a>
                <a href="#research" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1321" data-mp="2cuvyl02mats0">
                  Research
                </a>
                <a href="#partnerships" className="block px-3 py-2 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1322" data-mp="fzrkwms4g5jh">
                  Partnerships
                </a>
              </div>

              {navItems.map(item => <a key={item} href={`#${item.toLowerCase()}`} className="block px-3 py-3 text-base font-medium text-ink-dark hover:bg-surface-muted rounded-md" onClick={() => setMobileMenuOpen(false)} data-id="element-1323" data-mp="25hoekh228xqa">
                  {item}
                </a>)}
              <div className="pt-4 px-3" data-id="element-1324" data-mp="2t6zho56vv47l">
                <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="block w-full text-center bg-navy text-white font-medium px-5 py-3 rounded-md shadow-sm" data-id="element-1325" data-mp="2o8xqsy37u0lk">
                  Request Demo
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}